import { Component, NgZone, OnInit } from '@angular/core';
import { FormBuilder, NgForm } from '@angular/forms';
import * as $ from 'jquery';
import { BsModalService, ModalOptions, BsModalRef } from 'ngx-bootstrap/modal';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { CustomService } from '../../services/frapper/custom.service';
import { DossierService } from '../../services/frapper/dossier.service';
import { UsercourrierService } from '../../services/frapper/usercourrier.service';
import { PenalCourrierService } from '../../services/penal.courrier/penal.courrier.service';
import { AlertesService } from '../../services/public/alertes.service';
import {DemandesService} from "../../services/frapper/demandes.service";
import {DocumentService} from "../../services/frapper/document.service";
import { VisualizeDemandevisiteComponent } from '../visualize-demandevisite/visualize-demandevisite.component';
import { MyCONST } from '../../CONST/myConst';
import { VisualizePieceComponent } from '../visualize-piece/visualize-piece.component';
import * as QRCode from 'qrcode';
import { DatePipe } from '@angular/common';
import { error } from 'console';


@Component({
  selector: 'app-add-demandes',
  templateUrl: './add-demandes.component.html',
  styleUrls: ['./add-demandes.component.scss']
})
export class AddDemandesComponent implements OnInit {
  template_demande: any
  type: any = null;
  type_doctype :any = null;
  numero_du_jugement : any = null;
  fileNames: { [key: string]: string } = {};
  imageFile:any ={}
  is_stepped: boolean = false;
  data: any = null;
  getTheFiles: boolean = false;
  pagefiles:number = 1;
  show_editor:boolean = false
  is_new:any = false

    tribunal = MyCONST.TRIBUNAL
    tribunal_detail = MyCONST.DETAIL_TRIBUNAL
  
    profil: string ;
  
    base64Image: string = '';
   _elementsArray = []
   content_default:any
  listedemandes = [
    {

      type_demande:"visite detenu",

      content:{
        nom_visiteur: '',
        prenom_visiteur: '',
        date_naissance: '',
        lieu_naissance: '',
        num_piece: '',
        date_delivrance_piece: '',
        profession: '',
        adresse: '',
        affiliation: '',
        lieu_detention: '',
        nom_detenu: '',
        prenom_detenu: '',

      },
    },
    {
      type_demande:"autre",

      content:{
        testchamp1: '',
        testchamp2: '',
        testchamp3: '',
        testchamp4: '',

      },
    },
    {
      type_demande:"xxxxx",

      content:{
        nom_visiteur: '',
        prenom_visiteur: '',
        date_naissance: '',
        lieu_naissance: '',
        num_piece: '',
        date_delivrance_piece: '',
        profession: '',
        adresse: '',
        affiliation: '',
        nom_detenu: '',
        prenom_detenu: '',
        lieu_detention: '',
      },
    },
  ]
  widthPercentage: number;
  steps_demande: any = [];
  item:any;
  fieldsByStep: any[] = [];
  elementsArray: Array<{ key: string; value: any }> = [];

  my_tribunal:any=null;

  categorie:any=null
  constructor(private modalService: BsModalService,
    public options: ModalOptions,
    private formBuilder: FormBuilder,
    private dossierService:DossierService,
    private customservice:CustomService,
              private demandeService:DemandesService,
              private documentService:DocumentService,
    private ngxService: NgxUiLoaderService,
    private alerte:AlertesService,
    private zone: NgZone,
     private datePipe: DatePipe,
    private custom: CustomService,
    public bsModalRef: BsModalRef,
    private userCourrierService:UsercourrierService,
    private penalService: PenalCourrierService) {
    this.type =  this.options.initialState.type;
    this.data =  this.options.initialState.data != undefined ? this.options.initialState.data:null;
    this.item =  this.options.initialState.item;
    this.type_doctype = this.options.initialState.type_doctype;
    this.numero_du_jugement = this.options.initialState.numero_du_jugement;
    this.is_new = this.options.initialState.is_new;
    console.log('the type=>', this.type);

    try{
      this.categorie =  this.options.initialState.categorie;
    }catch (e) {
      this.categorie =  null
    }
    try{
      this.my_tribunal= JSON.parse(localStorage.getItem('my_tribunal'))
      //console.log('tribunal_information====> ',tribunal_information)
    }catch (e) {
      console.log('ERROR ON GET TRIBUNAL====> ')
      this.my_tribunal=null
    }

    this.profil = localStorage.getItem('profil');

    console.log('thedaattta====> ', this.data)
    console.log('cat====> ', this.categorie)
    console.log('optionsss====> ', this.options.initialState)
  }


  generateRandomString(): any {
    const length = 5;
    const characters = '0123456789';
    let result = '';

    for (let i = 0; i < length; i++) {
      const randomIndex = Math.floor(Math.random() * characters.length);
      result += characters.charAt(randomIndex);
    }

    return  result;
  }

  closeModal(){
    this.bsModalRef.hide()
  }
  replaceUndefinedValue(obj) {
    for (let key in obj) {
        if (obj[key] === undefined) {
            obj[key] = '';
        }
    }
    return obj;
}
  replaceUndefinedWithEmptyString(value) {
  return value === undefined ? '' : value;
}




// adapter le content si la demande a des steps
 buildContent(steps, formValues) {
  let content = {};

  steps.forEach((step, u) => {
      content[`step${u}`] = {
          name_step: step.name_step,
          fields: {}
      };

      this.fieldsByStep[u].forEach(field => {
          // Récupérer la valeur du champ dans le formulaire ou mettre une chaîne vide
          content[`step${u}`].fields[field.key] = this.replaceUndefinedWithEmptyString(formValues[field.key]);
      });
  });

  return content;
}
closeWithMessage(message: string) {
  this.bsModalRef.hide();
  this.bsModalRef.onHidden.emit(message);
}

updateTemplate(demande: NgForm,finished:boolean = false){
  this.ngxService.start()
  let visualize = false
  this.item.template = this.content_default
  let body = {
    template: this.item.template, //default template of type_demande
  };
  if (finished) {
    body['status'] = "confirmer"
    visualize = true
  }
  
  if (this.is_new) {
    this.AddDemande(demande)
  }

  try {
    console.log('update doc=>', body);
    let i = this.template_demande.name;
    console.log('namedoc=>', i);
    // this.item.template = this.transform(this.item.template);

    console.log('the template=>',this.item.template);
    
    this.documentService.updateDocument(i,body).then(async res => {
        this.alerte.successNotification(this.template_demande.name, 'Document Modifié avec succè!');
        // this.bsModalRef.hide();

       
        this.closeWithMessage("success")
        this.ngxService.stop();
        if (finished) {
          this.openModalVisualizeD_visite(res.data,visualize)
        }
       


    }, err => {
      this.ngxService.stop();
    });
   } catch (error) {
    this.alerte.successNotification(this.item.name, 'Impossible d\'effectuer l\'operation !');
    this.ngxService.stop();
   }
}


  AddDemande(demande: NgForm) {
  this.ngxService.start();
  // Charger les images dans les valeurs du formulaire
  const ImagesCharged = Object.keys(this.imageFile);
  for (let key of ImagesCharged) {
      demande.value[key] = this.imageFile[key];
  }

  console.log('document body sended', this.data);

  let _signataires = [
    {
      profil_du_signataire: this.profil,
      nom_du_signataire: localStorage.getItem('me_username'),
      signature:null
    }
  ]
  // Construire le corps de la requête
    if (this.categorie=='document'){
      console.log('is document');
      let body = {
        template_name: this.item.name,
        template: this.item.template, //default template of type_demande
        is_decision:0,
        flag: this.item.flag,
        type_doctype: this.type_doctype,
        numero_du_jugement: this.type_doctype == "Dossier"? this.numero_du_jugement: this.data?.name??null,
        content: this.is_stepped? this.buildContent(this.steps_demande, demande.value): this.replaceUndefinedValue(demande.value),
        signataires: _signataires
      };
      if(this.my_tribunal !=null){
        body["tribunal"]= this.my_tribunal.name
      }
      console.log('document body sended', body);
     try {
      this.documentService.nouveauDocument(body).then(async res => {
        if (res != null) {
          this.alerte.successNotification(this.item.name, 'Document généré avec succè!');
          // this.bsModalRef.hide();

          // mis a jours des contraintes a corps dans dossier
          if (this.type_doctype == "Dossier" || this.type_doctype == "Jugement") {
            if (this.type == "MANDAT DE DEPOT") {
              let table_tqhi = {
                "table_tqhi": [{
                  "debut": demande.value['debut'],
                  "fin": demande.value['fin'],
                  "main_leve": demande.value['main_leve']
                }]

              }
              console.log('table_tqhi', table_tqhi);

              await this.dossierService.updateDossier(this.numero_du_jugement,table_tqhi).then(res=>{

                this.alerte.successNotification('Dossier','Mise a jour effectuee!')
                this.closeWithMessage('success')
              console.log('dossier updated: ', res)
                this.ngxService.stop()
              },err=>{
                this.alerte.errorNotification('Dossier','Erreur lors de la mise a jour du dossier')
                this.ngxService.stop()
              })
            }

          }
        }else {
          this.alerte.errorNotification(this.categorie, 'Erreur lors de la création.');
        }
         
          this.closeWithMessage("success")
          this.ngxService.stop();
          this.openModalVisualizeD_visite(res.data,false)


      }, err => {
        this.ngxService.stop();
      });
     } catch (error) {
      this.alerte.successNotification(this.item.name, 'Impossible d\'effectuer l\'operation !');
      this.ngxService.stop();
     }

    }
    else {
      console.log('is demande');
      
      let body = {
        type_demande: this.item.name,
        code: this.generateRandomString(),
        flag: this.item.flag,
        content: this.is_stepped? this.buildContent(this.steps_demande, demande.value): this.replaceUndefinedValue(demande.value)
      };
      if(this.my_tribunal !=null){
        body["tribunal"]= this.my_tribunal.name
      }
      // Logique de soumission de la demande
      this.demandeService.nouvelleDemande(body).then(res => {
        if (res) {
          this.alerte.successNotification(this.item.name, 'Demande effectuée avec succès!');
          this.closeWithMessage("success")
          this.ngxService.stop();
        }else{
          this.ngxService.stop();
          this.alerte.errorNotification(this.categorie, 'Erreur lors de la création.');
        }
       
      }, err => {
        this.alerte.successNotification(this.item.name, 'Impossible d\'effectuer l\'operation !');
        this.ngxService.stop();
      });
    }



}

openModalVisualizeD_visite(_data,visualize) {

  const config: ModalOptions = {
    initialState: {
      data: _data,
          type: _data.flag,
          item: _data,
          categorie:this.type,
          type_doctype: _data.type_doctype,
          numero_du_jugement:_data.numero_du_jugement,



    }
  }

  console.log('inthevisuallllll=>', _data);
  console.log('the visualize',visualize);
  

   // Ouvrir le modal   VisualizeDemandevisiteComponent
   const modalRef = this.modalService.show(VisualizeDemandevisiteComponent, Object.assign({}, config, { class: 'modal-lg ' }));

  //  if (!visualize) {
  //   const modalRef = this.modalService.show(AddDemandesComponent, Object.assign({}, config, { class: 'modal-xl ' }));

  //  }else{
  //   const modalRef = this.modalService.show(VisualizeDemandevisiteComponent, Object.assign({}, config, { class: 'modal-xl ' }));

  //  }

}
openModalVisualPiece(urlpiece: any = null) {
      const URL=MyCONST.API_URL+urlpiece
      console.log('dddd',urlpiece);
      if (urlpiece != "") {
        const config: ModalOptions = {
          initialState: {
            data: URL,
            url:URL,
            parentModal : null
          }
        }

         // Ouvrir le modal
         const modalRef = this.modalService.show(VisualizePieceComponent, Object.assign({}, config, { class: 'modal-lg  ' }));

      }else{
        this.alerte.warningNotification('aucune piéce téléchargée')
      }

       // Mettre à jour l'option initialState avec le modalRef
    }
  initializeStepper() {


    $(document).ready(function(){
      var current_fs, next_fs, previous_fs; //fieldsets
      var opacity;
      var current = 1;
      var steps = $("fieldset").length;


      setProgressBar(current);

      // Fonction pour définir la barre de progression
      function setProgressBar(curStep){
          var percent = (100 / steps) * curStep;
          percent = percent
          $(".progress-bar").css("width",percent+"%");
      }

      // Logique pour passer à l'étape suivante
      $(".next").click(function(){
          current_fs = $(this).parent();
          next_fs = $(this).parent().next();

          // Ajouter la classe "active" à l'étape suivante de la barre de progression
          $("#progressbar li").eq($("fieldset").index(next_fs)).addClass("active");

          // Afficher le fieldset suivant avec une animation
          next_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  next_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(++current);
      });

      // Logique pour revenir à l'étape précédente
      $(".previous").click(function(){
          current_fs = $(this).parent();
          previous_fs = $(this).parent().prev();

          // Retirer la classe "active" de l'étape actuelle de la barre de progression
          $("#progressbar li").eq($("fieldset").index(current_fs)).removeClass("active");

          // Afficher le fieldset précédent avec une animation
          previous_fs.show();
          current_fs.animate({opacity: 0}, {
              step: function(now) {
                  opacity = 1 - now;
                  current_fs.css({
                      'display': 'none',
                      'position': 'relative'
                  });
                  previous_fs.css({'opacity': opacity});
              },
              duration: 500
          });
          setProgressBar(--current);
      });
  });
//   $(document).ready(function() {
//     $(".file-input").on("change", function() {
//         // Récupérer le nom du fichier sélectionné
//         const fileName = $(this).val().split("\\").pop();
//         // Trouver l'élément span à l'intérieur du label parent et mettre à jour son texte
//         $(this).parent().find('.file-label').text(fileName);
//     });
// });
  }

//   getFormInputs() {
//        // verifier si il ya des steps
//        const nameStepCount = this.steps_demande.reduce((count, step) => {
//         return count + (step.name_step ? 1 : 0);
//     }, 0);
//     if (nameStepCount>0) {
//       this.is_stepped = true
//     }

//     if (this.is_stepped) {
//       this.fieldsByStep = this.steps_demande.map(step => this.getFields(step));
//       console.log('kkkkk',this.fieldsByStep);

//     }else{
//       for (const [key, value] of Object.entries(this.template_demande.content)) {
//         this.elementsArray.push({ key, value });
//       }
//     }





//     console.log('is name_step encountered: ', this.is_stepped);
// }
getFormInputs() {
  this.steps_demande = [];
  this.elementsArray = [];

  // Récupérer les clés de template_demande.content
  const keys = Object.keys(this.template_demande.content);

  // Vérifier s'il y a des clés qui commencent par 'step'
  const hasSteps = keys.some(key => key.startsWith('step'));

  if (hasSteps) {
    this.is_stepped = true;
    this.steps_demande = keys
      .filter(key => key.startsWith('step'))
      .map(key => this.template_demande.content[key]);

    this.fieldsByStep = this.steps_demande.map(step => this.getFields(step));
  } else {
    this.is_stepped = false;
    for (const [key, value] of Object.entries(this.template_demande.content)) {

      this.elementsArray.push({ key, value });
    }
  }

  console.log('elemetsss ', this.elementsArray);
}



getFields(step: any): any[] {
    return Object.entries(step)
        .filter(([key]) => key !== 'name_step')
        .map(([key, value]) => ({ key, value }));
}



  // getFormInputs(){
  //   for (const [key, value] of Object.entries(this.template_demande.content)) {
  //     this.elementsArray.push({ key, value });
  //   }
  //   console.log('the lengggg', this.elementsArray.length);

  //   this.widthPercentage = 100 / this.elementsArray.length;

  //   console.log('the lengggg perrr', this.widthPercentage);
  // }

  getKeys(content: any): string[] {
    return content ? Object.keys(content) : [];
  }
  // get the files url for file input
  getUrlFiles(){
    if (this.data != null) {
      const keys = Object.keys(this.data.content);
    // Vérifier s'il y a des clés qui commencent par 'step'
    const hasSteps = keys.some(key => key.startsWith('step'));


    if (hasSteps) {
      let mysteps_demande = keys
        .filter(key => key.startsWith('step'))
        .map(key => this.data.content[key]);

      let _fieldsByStep = mysteps_demande.map(step => this.getFields(step));
      console.log('fields=> ',_fieldsByStep);
      _fieldsByStep.forEach(itemArray => {
        itemArray.forEach(item => {
            if (item.key === "fields") {
                const fields = item.value;
                // Parcourir les champs et afficher les valeurs
                for (const [key, value] of Object.entries(fields)) {
                    console.log(`${key}: ${value}`);
                    if (key.startsWith('file_')) {
                      this._elementsArray.push({key,value})
                    }

                }

            }
        });
      });
      console.log('the _elets=>', this._elementsArray);

    } else {

      for (const [key, value] of Object.entries(this.data.content)) {

        this._elementsArray.push({ key, value });
      }
      console.log('eletsarr=> ',this._elementsArray);
    }
    }


  }



  onFileSelected(event: any, key: string) {
    let image: any = event.target.files[0] as File;

    if (image) {
      this.fileNames[key] = image.name; // Store the name of the file
      console.log('this.imageFile ==> ', image.name);
      this.createPiece(image, key);
    }
  }

  createPiece(file: File, key: string) {
    this.ngxService.start();

    const formData1 = new FormData();
    formData1.append('is_private', '0');
    formData1.append('file', file);

    this.custom.createFiles(formData1).then(res => {
      // Update imageFile or fileNames after upload completes
      this.imageFile[key] = res.message.file_url;
      console.log('lll',this.imageFile[key]);

      // Optionally, store the filename in fileNames if needed
      this.fileNames[key] = res.message.file_name || this.fileNames[key]; // Update the filename if returned
      console.log(this.fileNames)
      this.ngxService.stop();
    }, err => {
      this.ngxService.stop();
      this.alerte.errorNotification('Pieces', 'Une erreur s\'est produite!');
    });
  }
  formatLabel(key: string): string {
    // remove "file_" prefix and format the rest of the key
     if (key.startsWith('file_')) {
       return key.replace('file_', '').replace(/_/g, ' ').replace(/\b\w/g, char => char); // Remove "file_" and format
     }

     return key.replace(/_/g, ' ').replace(/\b\w/g, char => char);
     }


     remplacerVariables(template, donnees) {
      let mytemplate = template;
      let correspondanceTrouvee = false;
      console.log({'the te1': template});
      console.log({'the te1': donnees});
      if (typeof donnees === 'object' && this.template_demande.content !== null){
        donnees = donnees
        console.log('jhjhjh=>', donnees);
  
       }else{
        donnees = JSON.parse(donnees)
        console.log('jhjhjh=>', donnees);
        
       }
      
  
      for (let key in donnees) {
        
        if (donnees.hasOwnProperty(key)) {
          //  let regex = new RegExp("$_" + key + "_$", "g");
          let regex = new RegExp("\\$_" + key + "_\\$", "g");
          // if (donnees[key] == null || donnees[key] === undefined) {
          //   mytemplate = mytemplate.replace(regex, '.........');
          // } else {
          //   mytemplate = mytemplate.replace(regex, donnees[key]);
          //   correspondanceTrouvee = true;
          // }
  
          // Vérifier si la valeur de l'attribut est null ou n'existe pas
          if (donnees[key] == null || donnees[key] === undefined ) {
            mytemplate = mytemplate.replace(regex, '.........');
          } else if (donnees[key].value == "") {
            mytemplate = mytemplate.replace(regex, '.........');
          }
          else {
            mytemplate = mytemplate.replace(regex, donnees[key]);
            correspondanceTrouvee = true;
          }
        }
      }
  
     let model_final =  this.filter_remplacerVariables(mytemplate,donnees)
  
  
      return model_final;
    }
  
    filter_remplacerVariables(template, jugement) {
      let mytemplate = template;
      let modeleFinal: any;
  
      // Expression régulière pour récupérer les mots commencant par $_ et terminant par _$
      let regexPattern = /\$_([^$]+)_\$/g;// Échapper les caractères spéciaux dans la chaîne de la RegExp
  
    modeleFinal = mytemplate.replace(regexPattern, '...........................')
      return modeleFinal;
    }

    transform(template_value: string): string {
      // Utilisation d'une expression régulière pour trouver et remplacer l'image QR code
      return template_value.replace(
        // /<img[^>]+src="data:image\/(png|jpg|jpeg);base64,[^"]+"[^>]*>/g,
        /<img(?![^>]*src)[^>]*>|<img[^>]+src="data:image\/(png|jpg|jpeg);base64,[^"]+"[^>]*>/g,
        '$_the_qr_$'
      );
      
    }

    replacePlaceholders(template:any): string {
      let parsed_data_content;
      console.log('kkk',template);
         // content qr_code
         if (typeof  this.template_demande.content === 'object' &&  this.template_demande.content !== null){
          parsed_data_content =  this.template_demande.content;
         }else{
          parsed_data_content = JSON.parse( this.template_demande.content);
         }
        //  let parsed_data_content = JSON.parse( this.template_demande.content);
         let content_qrcode = `${this.template_demande.doctype}@${parsed_data_content?.cabinet_instruction}` ;
      this.generateQRCode(content_qrcode)
      
      // Liste des cles  à remplacer avec leurs valeurs
      const placeholders: { [key: string]: string } = {
        '$_tribunal_detail_$': this.tribunal_detail,
        '$_tribunal_$': this.tribunal,
        '$_date_generation_$': this.getFormattedDate(this.template_demande.creation) ,
        '$_the_qr_$': `<div style="width: 60px; height: 60px; background-image: url('${this.base64Image}'); background-size: cover;" alt="QR Code"> </div>`
  
      };
    
      // Remplacer chaque clee avec sa valeur correspondante
      Object.keys(placeholders).forEach(placeholder => {
        // Créer une expression régulière dynamique pour chaque placeholder
        const regex = new RegExp(this.escapeRegExp(placeholder), 'g');
        const value = placeholders[placeholder];
    
        // Remplacer le clee par la valeur dans le template
        template = template.replace(regex, value);
      });
      console.log('kkkjj',template);
    
      return template;
    }
    getFormattedDate(date): string {
      return this.datePipe.transform(date, 'dd-MM-yyyy');
    }

    generateQRCode(text: string): void {
        QRCode.toDataURL(text, { errorCorrectionLevel: 'L' }, (err, url) => {
          if (err) throw err;
          this.base64Image = url; 
        });
      }
    
     escapeRegExp(string: string): string {
      return string.replace(/[.*+?^=!:${}()|\[\]\/\\]/g, '\\$&'); // Échappe les caractères spéciaux
    }
  ngOnInit() {
    this.show_editor = false
    // pour charger les files
    if (this.type?.includes('NATIONALITE')) {
      this.getUrlFiles()
    }



    //this.template_demande = this.listedemandes.find(template => template.type_demande.toLowerCase() === this.type.toLowerCase());
    this.template_demande =this.item
    console.log('thetemplate=>',this.template_demande );

    switch (this.categorie) {
      case 'demande':
        this.steps_demande = Object.values(this.template_demande.content);
        console.log('steps demandede==> ', this.steps_demande);
        this.widthPercentage = 100 / this.steps_demande.length;
  
        this.getFormInputs()
        break;
      case 'document':
        
        if (this.is_new) {
         
          if (this.template_demande.use_template == 1 ) {
            if (this.data?.content != null) {
              this.template_demande.content = this.data.content
            }
            this.show_editor = true
            this.content_default =   this.remplacerVariables( this.replacePlaceholders( this.template_demande.template), this.template_demande.content)
          }else{
            this.steps_demande = Object.values(this.template_demande.content);
            console.log('steps demandede==> ', this.steps_demande);
            this.widthPercentage = 100 / this.steps_demande.length;
      
            this.getFormInputs()
          }
        }else{
          console.log('in else=>', this.template_demande.content);
          if (this.data?.content != null) {
            this.template_demande.content = this.data.content
          }
          this.show_editor = true
          console.log('show_editor', this.show_editor);
          
          this.content_default =   this.remplacerVariables( this.replacePlaceholders( this.template_demande.template), this.template_demande.content)
        }
       
        break;
      default:
        break;
    }
   
    

    console.log('with value ',this.elementsArray);
    console.log('add demande template', this.template_demande);

    if (this.template_demande == null) {
      this.bsModalRef.hide();
      this.alerte.warningNotification('ajout demande','Aucune demande correspondante')
    }

    var self = this;
    $(document).ready(function(){
      console.log('dddddd rrreeaady');

      self.initializeStepper();
      console.log('jjbjjn');
        // Ajouter une nouvelle ligne au tableau
        $('#addRowBtn').on('click', function() {

        });

        // Gérer la suppression d'une ligne
        $('#myTable').on('click', '.delete-row', function() {
          $(this).closest('tr').remove(); // Supprimer la ligne parente (tr) du clic sur l'icône poubelle (delete-row)
        });



    })
  }

}
